import fetch from 'node-fetch';
import isEmpty from 'lodash/isEmpty';
import { stringify } from 'querystring';
import FormData from 'form-data';

const http = require('http');

export const post = async({ url, data, ...options }) => {
  let fd;
  try {
    const { Truthy: obj2fd } = require('./obj2fd');
    fd = obj2fd(data, new FormData);
  } catch (error) {
    console.log(error.stack || error);
  }
  return await fetch(url, {
    agent: new http.Agent({ keepAlive: true }),
    method: 'POST',
    body: fd,
    ...options,
  }).then(res => res.json() || {})
    .catch(error => error);
};

export const put = async({ url, data, ...options }) => {
  let fd;
  try {
    const { Truthy: obj2fd } = require('./obj2fd');
    fd = obj2fd(data, new FormData);
  } catch (error) {
    console.log(error.stack || error);
  }
  return await fetch(url, {
    method: 'PUT',
    body: fd,
    ...options,
  }).then(res => res.json() || {})
    .catch(error => error);
};

export const remove = async({ url, params, ...options }) => {
  // let fd;
  // try {
  //   const { Truthy: obj2fd } = require('./obj2fd');
  //   fd = obj2fd(data, new FormData);
  // } catch (error) {
  //   console.log(error.stack || error);
  // }
  return await fetch(`${url}${isEmpty(params) ? '' : `?${stringify(params)}`}`, {
    method: 'DELETE',
    // body: fd,
    ...options,
  }).then(res => res.json() || {})
    .catch(error => error);
};

export const get = async({ url, params, ...options }) => {
  return await fetch(`${url}${isEmpty(params) ? '' : `?${stringify(params)}`}`, {
    method: 'GET',
    ...options
  }).then(res => res.json() || {}).catch(error => error);
};